import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import ConversationFlowsAPI from '../../api/conversationFlows';
import types from '../mutation-types';

export const state = {
  records: [],
  selectedRecord: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getConversationFlows(_state) {
    return [..._state.records].sort((flowA, flowB) => {
      const dateA = new Date(
        flowA.updated_at || flowA.created_at || 0
      ).getTime();
      const dateB = new Date(
        flowB.updated_at || flowB.created_at || 0
      ).getTime();
      return dateB - dateA || flowB.id - flowA.id;
    });
  },
  getConversationFlow(_state) {
    return _state.selectedRecord;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getConversationFlows({ commit }) {
    commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isFetching: true });
    try {
      const response = await ConversationFlowsAPI.get();
      commit(types.SET_CONVERSATION_FLOWS, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isFetching: false });
    }
  },
  show: async function showConversationFlow({ commit }, id) {
    commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isFetching: true });
    try {
      const response = await ConversationFlowsAPI.show(id);
      commit(types.SET_CONVERSATION_FLOW, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createConversationFlow({ commit }, flow) {
    commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isCreating: true });
    try {
      const response = await ConversationFlowsAPI.create(flow);
      const record = response.data.payload || response.data;
      commit(types.ADD_CONVERSATION_FLOW, record);
      return record;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...flow }) => {
    commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isUpdating: true });
    try {
      const response = await ConversationFlowsAPI.update(id, flow);
      commit(types.EDIT_CONVERSATION_FLOW, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isDeleting: true });
    try {
      await ConversationFlowsAPI.delete(id);
      commit(types.DELETE_CONVERSATION_FLOW, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CONVERSATION_FLOW_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CONVERSATION_FLOW_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_CONVERSATION_FLOW](_state, data) {
    _state.selectedRecord = data;
  },
  [types.ADD_CONVERSATION_FLOW]: MutationHelpers.create,
  [types.SET_CONVERSATION_FLOWS]: MutationHelpers.set,
  [types.EDIT_CONVERSATION_FLOW]: MutationHelpers.update,
  [types.DELETE_CONVERSATION_FLOW]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
